import React, { createContext, useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getVolunteerByAuthUid, getVolunteerByEmail } from '../services/firebase';

export const VolunteerAuthContext = createContext(null);

export function VolunteerAuthProvider({ children }) {
  const [firebaseUser, setFirebaseUser] = useState(undefined); // undefined = loading
  const [volunteer, setVolunteer] = useState(null);
  const [volLoading, setVolLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, async (user) => {
      setFirebaseUser(user);
      if (!user) {
        setVolunteer(null);
        setVolLoading(false);
        return;
      }
      // Try UID first, then email
      let vol = await getVolunteerByAuthUid(user.uid);
      if (!vol && user.email) {
        vol = await getVolunteerByEmail(user.email.toLowerCase());
      }
      setVolunteer(vol);
      setVolLoading(false);
    });
    return unsub;
  }, []);

  const refreshVolunteer = async () => {
    if (!firebaseUser) return;
    let vol = await getVolunteerByAuthUid(firebaseUser.uid);
    if (!vol && firebaseUser.email) {
      vol = await getVolunteerByEmail(firebaseUser.email.toLowerCase());
    }
    setVolunteer(vol);
  };

  return (
    <VolunteerAuthContext.Provider value={{ firebaseUser, volunteer, volLoading, refreshVolunteer }}>
      {children}
    </VolunteerAuthContext.Provider>
  );
}
